import { inject, Injectable } from '@angular/core';

import { HttpService } from '@bbraun/helpex/src/lib/http';
import { environment } from '@environment/environment';
import { HttpParamsFactory } from '@shared/factory/http-params/http-params.factory';
import { ProductManager } from '@shared/interfaces/product-manager/product-manager.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductManagersService {
  private readonly httpService = inject(HttpService);
  private readonly productManagerRoute = 'productManagers';

  public getProductManagers(name?: string): Observable<Array<ProductManager>> {
    const params = new HttpParamsFactory({ name }).returnParams();
    return this.httpService
      .request(this.productManagerRoute)
      .params(params)
      .get(environment.backendUrl);
  }

  public getProductManagerById(id: number): Observable<ProductManager> {
    return this.httpService
      .request(this.productManagerRoute + `/${id}`)
      .get(environment.backendUrl);
  }

  public putProductManager(productManager: ProductManager): Observable<ProductManager> {
    return this.httpService
      .request(this.productManagerRoute + `/${productManager.id}`)
      .body(productManager)
      .put(environment.backendUrl);
  }

  public postProductManager(
    productManager: Omit<ProductManager, 'id'>
  ): Observable<ProductManager> {
    return this.httpService
      .request(this.productManagerRoute)
      .body(productManager)
      .post(environment.backendUrl);
  }

  public deleteProductManagerById(id: number): Observable<void> {
    return this.httpService
      .request(this.productManagerRoute + `/${id}`)
      .delete(environment.backendUrl);
  }
}
